module.exports = __webpack_public_path__ + "static/img/logo_013.1a3f3560.png";